// extracted by mini-css-extract-plugin
export var root = "header-module--root--2Pllp";
export var wrapper = "header-module--wrapper--182n5";
export var branding = "header-module--branding--1PjA2";
export var toggleNavButton = "header-module--toggleNavButton--34Tf4";
export var closeNavButton = "header-module--closeNavButton--1S9Rf";
export var nav = "header-module--nav--106zH";
export var listWrapper = "header-module--listWrapper--3IdMi";
export var showNav = "header-module--showNav--CuuOZ";
export var desktopNav = "header-module--desktopNav--3tweO";